import React from "react";
import { Field, sourceLabel } from "./Fields";
import SourceButton from "./sources/SourceButton";
import HtsInput from "./HtsInput";

/** Pozycje zachowują identyfikator również po korekcie kodu produktu. */
export default function GoodsEditor({
  items,
  grossWeight,
  options,
  documents,
  setItems,
  onWeightChange,
  onShowSource,
}) {
  const columns = [
    ["sap", options.productCodeLabel || "Kod produktu"],
    ["hts", "HTS"],
    ["description", "Opis towaru"],
    ["origin", "Kraj pochodzenia"],
    ["quantity", options.quantityLabel || "Ilość"],
    ["unit", "Jednostka"],
  ];
  const updateItem = (index, field, value) =>
    setItems(
      items.map((item, i) =>
        i === index ? { ...item, [field]: value } : item,
      ),
    );
  return (
    <section className="card premium-panel">
      <h2>6–7. Towary i ilości</h2>
      <p className="small text-muted">{options.goodsHint}</p>
      <div className="table-responsive">
        <table className="table premium-items">
          <thead>
            <tr>
              <th>LP</th>
              {columns.map(([field, label]) => (
                <th key={field}>{label}</th>
              ))}
              <th />
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.id} id={`premium-item-${item.id}`}>
                <td>
                  <span className="premium-item-number">{index + 1}</span>
                </td>
                {columns.map(([field, label]) => (
                  <td key={field}>
                    {field === "hts" ? (
                      <HtsInput
                        label={`${label} ${index + 1}`}
                        value={item[field] ?? ""}
                        onChange={(event) =>
                          updateItem(index, field, event.target.value)
                        }
                      />
                    ) : field === "description" ? (
                      <textarea
                        aria-label={`${label} ${index + 1}`}
                        className="form-control"
                        rows={1}
                        value={item[field] ?? ""}
                        onChange={(event) =>
                          updateItem(index, field, event.target.value)
                        }
                      />
                    ) : (
                      <input
                        aria-label={`${label} ${index + 1}`}
                        className="form-control"
                        value={item[field] ?? ""}
                        maxLength={field === "origin" ? 2 : 100}
                        onChange={(event) =>
                          updateItem(index, field, event.target.value)
                        }
                      />
                    )}
                    {field === "sap" && (
                      <span className="premium-source-location">
                        <span className="premium-source">
                          {[
                            ...new Set(
                              (item.sources || [])
                                .map((source) => sourceLabel(source, documents))
                                .filter(Boolean),
                            ),
                          ].join(", ") || "Wpis ręczny"}
                        </span>
                        {item.sources?.length > 0 && (
                          <SourceButton
                            highlighted={item.sources.some(
                              (entry) => entry.regions?.length,
                            )}
                            onClick={
                              onShowSource &&
                              (() =>
                                onShowSource(item.sources, { item: item.id }))
                            }
                          />
                        )}
                      </span>
                    )}
                  </td>
                ))}
                <td>
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    aria-label={`Usuń pozycję ${index + 1}`}
                    onClick={() =>
                      setItems(items.filter((_, i) => i !== index))
                    }
                  >
                    Usuń
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        className="btn btn-outline-primary premium-space-after"
        onClick={() =>
          setItems([
            ...items,
            {
              id: crypto.randomUUID(),
              sap: "",
              hts: "",
              description: "",
              origin: "",
              quantity: "",
              unit: "",
              sources: [],
            },
          ])
        }
      >
        Dodaj pozycję
      </button>
      <Field
        label={options.grossWeightLabel || "Łączna masa brutto (kg)"}
        inputMode="decimal"
        value={grossWeight}
        onChange={(event) => onWeightChange(event.target.value)}
      />
    </section>
  );
}
